module.exports = __webpack_public_path__ + "img/partner_linfei.7ec17e6b.png";